<template>
  <v-tooltip
    bottom
    transition="fade-transition"
    :disabled="listItem || !tooltip"
  >
    <template #activator="{ on, attrs }">
      <v-chip
        class="tag cursor-pointer"
        :class="{
          'tag--list-item': listItem,
          'pl-0': isExclusionMode,
        }"
        x-small
        :color="color"
        v-bind="{ ...attrs, ...$attrs }"
        v-on="{ ...on, ...$listeners }"
      >
        <span v-if="isExclusionMode" class="tag__text--prefix"> ∌ </span>
        <span class="tag__text" :style="{ color: textColor }">
          {{ tag.name }}
        </span>
      </v-chip>
      <div v-if="listItem" class="tag__description--list-item pl-1">
        {{ tag.description }}
      </div>
    </template>
    <div class="tag__description">
      {{ tag.description }}
    </div>
  </v-tooltip>
</template>

<script lang="ts">
import Vue, { PropType } from "vue"
import chroma from "chroma-js"
import { stringToColor } from "@evercam/shared/utils"
import { TagSelectorItem } from "@evercam/shared/types"

export default Vue.extend({
  name: "TagChip",
  props: {
    tag: {
      type: Object as PropType<TagSelectorItem>,
      required: true,
    },
    listItem: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Boolean,
      default: true,
    },
    isExcluded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isExclusionMode(): boolean {
      return this.tag.isExcluded || this.isExcluded
    },
    color(): string {
      if (this.isEError) {
        return "#ffb58b"
      } else if (this.isSError) {
        return "#ff8e8e"
      }

      return stringToColor(this.tag.name, {
        cleanString: true,
        saturation: 0.95,
        lightness: 0.55,
      })
    },
    textColor(): string {
      return chroma.contrast(this.color, "white") > 4.5 ? "#fff" : "#000"
    },
    isEError(): boolean {
      return this.tag.name.startsWith("E-")
    },
    isSError(): boolean {
      return this.tag.name.startsWith("S-")
    },
  },
})
</script>

<style scoped lang="scss">
.tag {
  &.v-chip {
    padding: 0 9px;
  }
  &__text {
    font-size: 12.8px;
    color: black;
    &--prefix {
      background: #2c2c2c;
      color: white;
      width: 1.25rem;
      text-align: center;
      margin-right: 0.25rem;
    }
  }
  &.tag--list-item {
    flex: 0 0 auto;
    &.v-chip {
      padding: 0 12px;
      height: 20px;
      border-radius: 20px;
    }
  }
  &__description {
    max-width: 16rem;
    &--list-item {
      padding-top: 0.2rem;
      color: var(--v-secondary-darken2);
    }
  }
}
</style>
